export function readApiErrorMessage(error, fallback) {
    const data = error?.response?.data;
    if (!data) return fallback;
    if (typeof data.detail === "string" && data.detail) return data.detail;

    const fieldMessages = Array.isArray(data.validation_errors)
        ? data.validation_errors.map((item) => item?.message).filter(Boolean)
        : [];
    if (data.message && fieldMessages.length) {
        return `${data.message}：${fieldMessages.join("；")}`;
    }
    if (typeof data.message === "string" && data.message) return data.message;
    return fallback;
}
